import styled from "styled-components";

export const Section = styled.section`
  padding: 8rem 0;
`;

export const HeadingPrimary = styled.h2`
  font-size: 3rem;
  text-align: center;
  letter-spacing: var(--mainSpacing);
  padding-bottom: 1rem;
  text-transform: capitalize;
`;

export const HeadingSecondary = styled.h2`
  letter-spacing: var(--mainSpacing);
  padding-bottom: 2rem;
`;

export const HeadingTertiary = styled.h3`
  text-transform: uppercase;
  padding-bottom: 2rem;
  letter-spacing: var(--mainSpacing);
`;
